module.exports = __webpack_public_path__ + "img/PE.738f2837.svg";